import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SetupLayout } from '@/features/admin';
import { BanksPage } from '@/features/banks-products';

/** Banks & products is a Setup tab; bank and product records below /banks keep their own record headers. */
export const Route = createFileRoute('/_app/banks/')({
  // B1: ?view=institutions lists the full bank master (reference institutions and their search aliases).
  validateSearch: z.object({ view: z.enum(['partners', 'institutions']).optional().catch(undefined) }),
  component: function Banks() {
    const { view } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <SetupLayout>
        <BanksPage view={view ?? 'partners'} onViewChange={(v) => void navigate({ search: v === 'partners' ? {} : { view: v }, replace: true })} />
      </SetupLayout>
    );
  },
});
